import { useEffect, useState } from "react";
import "./Search.css";
import SubjectSearch from "./Components/SubjectSearch";
import FilterBox from "./Components/FilterBox";
import ResultBox from "./Components/ResultBox";
import { useDispatch, useSelector } from "react-redux";
import { fetchTutors, setFilters } from "../../store/search";

const Search = () => {
  const { filters } = useSelector((state) => state.search);
  const { subject, level } = filters;
  const [loading, setLoading] = useState(true);
  
  const dispatch = useDispatch();
  
  const setSubject = (value) => dispatch(setFilters({ subject: value }));
  const setSelectedLevel = (value) => dispatch(setFilters({ level: value }));

  // Initial load - fetch tutors on mount
  useEffect(() => {
    let filterParams = {};
    if (subject) filterParams.subject = subject;
    if (level) filterParams.level = level;
    filterParams.price = filters.price.join(",");

    dispatch(fetchTutors({ filterParams, setLoading }))
      .unwrap()
      .catch((error) => {
        console.error("Error fetching tutors:", error);
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only run on mount

  return (
    <div className="search-container">
      <div className="search-left">
        <FilterBox setLoading={setLoading} />
      </div>

      <div className="search-right">
        <SubjectSearch
          setSubject={setSubject}
          setSelectedLevel={setSelectedLevel}
          setLoading={setLoading}
        />
        <ResultBox loading={loading} setLoading={setLoading} />
      </div>
    </div>
  );
};

export default Search;
